<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="local"
  (click)="onClickWidget()"
>

  <ion-list class="widget-data-list">

    @if (loadedData || isStoreView) {

      @for (order of widgetData | slice: 0: 3; track order.id) {

        <app-yu-custom-item
          class="yu-item"
          colorIcon="medium"
          icon="package"
          [showImage]="!!order.proveedor_logo"
          [image]="order.proveedor_logo"
          [state]="order.id_estado === orderStatus.sent && !order.enviado ? ('WIDGETS.HOME.PURCHASES.SENT_STATUS' | translate) : order.estado"
          [colorState]="tagManager.getColorTag(order, 'order')"
          [cost]="order.should_see_price_by_provider_context ? order.importe_iva : undefined"
        >
          <div content-label>
            <div class="description">{{ (order.fecha | date: 'dd/MM/yyyy') + ' | #' + order.ref }}</div>
            <div class="subtitle">{{ order.proveedor }}</div>
            <div class="description">{{ order.local }}</div>
          </div>
        </app-yu-custom-item>

      } @empty {

        <app-empty-item
          [detailEmpty]="true"
          [title]="'WIDGETS.HOME.PURCHASES.NO_ORDERS' | translate"
        ></app-empty-item>

      }

    } @else {

      <ion-skeleton-text [animated]="true"></ion-skeleton-text>

    }

  </ion-list>

</app-widget-home-core>
